var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C4.875 2.25 1.5 4.935 1.5 8.25C1.51893 9.047 1.71362 9.82999 2.07015 10.5431C2.42668 11.2561 2.93626 11.8817 3.5625 12.375C3.5625 12.825 3.2475 14.0025 1.5 15.75C3.2775 15.6675 4.98 15 6.3525 13.875C7.2075 14.1225 8.1075 14.25 9 14.25C13.125 14.25 16.5 11.565 16.5 8.25C16.5 4.935 13.125 2.25 9 2.25ZM9 12.75C5.685 12.75 3 10.7325 3 8.25C3 5.7675 5.685 3.75 9 3.75C12.315 3.75 15 5.7675 15 8.25C15 10.7325 12.315 12.75 9 12.75Z",
    fill: "#FFB143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGold);
export default __webpack_public_path__ + "static/media/chat-gold.0aae6da9be093743aa414a302652fa9d.svg";
export { ForwardRef as ReactComponent };